import { Map } from "../common/maps/map";
import { LatLng } from "../common/maps/lat-lng";
import { Notifications } from "./notifications";
export class AddressMap {
    constructor(domObject) {
        this._citySelector = ".js-city";
        this._centerSelector = ".js-centers";
        this._latitudeInputId = "latitude";
        this._longitudeInputId = "longitude";
        this._dataErrorKey = "noSelectedMessage";
        this.markerId = undefined;
        this.centeredToCity = false;
        this.map = new Map(domObject);
        this.messageError = domObject.dataset[this._dataErrorKey];
        this.latitudeInput = document.getElementById(this._latitudeInputId);
        this.longitudeInput = document.getElementById(this._longitudeInputId);
        this.map.onClick((coordinates) => this.onMapClick(coordinates));
        this.map.onInitialized(() => this.onMapInitialized());
    }
    onMapClick(coordinates) {
        if (this.markerId !== undefined) {
            this.map.removeMarker(this.markerId);
        }
        this.markerId = this.map.addMarker(coordinates);
        this.latitudeInput.value = coordinates.lat.toString();
        this.longitudeInput.value = coordinates.lng.toString();
    }
    onMapInitialized() {
        this.setCurrentMarkerIfExists();
        this.centerToCityWhenItChanges();
        this.centerToCenterWhenItChanges();
    }
    centerToCenterWhenItChanges() {
        const centerSelect = document.querySelector(this._centerSelector);
        centerSelect.addEventListener("change", () => {
            if (this.centeredToCity) {
                return;
            }
            this.centerToSelectOption(centerSelect);
        });
        if (this.markerId === undefined) {
            this.centerToSelectOption(centerSelect);
        }
    }
    centerToCityWhenItChanges() {
        const citySelect = document.querySelector(this._citySelector);
        $(citySelect).on("change", () => {
            this.centeredToCity = true;
            this.centerToSelectOption(citySelect);
        });
    }
    centerToSelectOption(citySelect) {
        if (citySelect.selectedOptions.length === 0) {
            return;
        }
        const cityCoordinates = new LatLng(parseFloat(citySelect.selectedOptions[0].dataset["lat"]), parseFloat(citySelect.selectedOptions[0].dataset["lng"]));
        this.map.centerToCoordinates(cityCoordinates);
    }
    setCurrentMarkerIfExists() {
        const latitude = this.latitudeInput;
        const longitude = this.longitudeInput;
        if (latitude.value && longitude.value) {
            const coordinates = new LatLng(parseFloat(latitude.value), parseFloat(longitude.value));
            this.markerId = this.map.addMarker(coordinates);
        }
    }
    static initialize(form) {
        const domObject = form.querySelector(this._mapContainerSelector);
        if (domObject === null) {
            return undefined;
        }
        return new AddressMap(domObject);
    }
    reportValidity() {
        if (this.markerId === undefined) {
            Notifications.error(this.messageError);
            return false;
        }
        return true;
    }
}
AddressMap._mapContainerSelector = ".js-address-map";
